import {useState} from "react";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {ProjectService} from "../../serverService/projectService/ProjectService";
import {
    dataURLtoFile,
    RaikoButtonPrimary,
    RaikoFlexAlignEnd,
    RaikoGridOneColumn,
    RaikoGridTwoColumn,
    RaikoLabel,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined,
    RaikoSimpleMultiLineInputOutlined,
    showErrorMessage, showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {stringIsEmpty} from "../../util/VariableChecker";
import {css} from "@emotion/css";
import RaikoCustomEditor2 from "../../raikoComponents/raikoEditor/RaikoCustomEditor2";
import InternalImageSelector from "../../raikoComponents/raikoEditor/internalImageSelector/InternalImageSelector";
import {FileManagerTypes} from "../../component/fileManager/FileManager";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

export default function ProjectAddNew({handleAddNewItemToTable}) {

    const loading = new LoadingHelper(useLoadingDispatcher())
    const service = new ProjectService()

    const [photoId, setPhotoId] = useState(-1)
    const [photoUrl, setPhotoUrl] = useState("");

    const [title, setTitle] = useState("");
    const [writerName, setWriterName] = useState("");
    const [shortDescription, setShortDescription] = useState("");
    const [description, setDescription] = useState([])


    function checkFields() {
        let state = false
        let message

        if (stringIsEmpty(title))
            message = "لطفا عنوان پروژه را به درستی وارد نمایید."
        else if (stringIsEmpty(writerName))
            message = "لطفا نام نویسنده پروژه را به درستی وارد نمایید."
        else if (photoId === -1)
            message = "لطفا تصویر شاخص پروژه را انتخاب نمایید."
        else if (stringIsEmpty(shortDescription))
            message = "لطفا توضیحات کوتاه پروژه را به درستی وارد نمایید."
        else if (description.length === 0)
            message = "لطفا توضیحات پروژه را به درستی وارد نمایید."
        else
            state = true

        if (message)
            showWarningMessage(message)

        return state

    }

    function handleAddNewItem() {
        if (checkFields()) {
            loading.show()
            service.addNewProject(
                title,
                writerName,
                photoId,
                shortDescription,
                description
            ).then(response => {
                handleAddNewItemToTable(response)
                showSuccessMessage("پروژه جدید با موفقیت افزوده شد.")
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }


    return (
        <RaikoGridOneColumn className={css`padding: 0 1rem 1rem 1rem`}>
            <RaikoGridTwoColumn>
                <RaikoSimpleInputOutlined
                    labelText={"عنوان"}
                    value={title}
                    setValue={setTitle}
                />
                <RaikoSimpleInputOutlined
                    labelText={"نویسنده"}
                    value={writerName}
                    setValue={setWriterName}
                />
            </RaikoGridTwoColumn>
            <InternalImageSelector
                value={photoUrl}
                setValue={setPhotoUrl}
                imageId={photoId}
                setImageId={setPhotoId}
                bucketId={FileManagerTypes.PROJECT_IMAGES.id}
                title={"تصویر شاخص"}
            />
            <RaikoSimpleMultiLineInputOutlined
                labelText={"توضیحات کوتاه"}
                value={shortDescription}
                setValue={setShortDescription}
            />
            <RaikoSectionContainer
                title={"توضیحات"}
                subTitle={"توضیحات کامل پروژه را در این قسمت وارد نمایید."}
            >
                <RaikoCustomEditor2 value={description} setValue={setDescription} bucketId={FileManagerTypes.PROJECT_IMAGES.id}/>
            </RaikoSectionContainer>
            <RaikoFlexAlignEnd>
                <RaikoButtonPrimary label={"افزودن"} onClick={handleAddNewItem}/>
            </RaikoFlexAlignEnd>

        </RaikoGridOneColumn>
    )
}
